import { render, staticRenderFns } from "./_DonationForm.vue?vue&type=template&id=247dcbdd&scoped=true&"
import script from "./_DonationForm.vue?vue&type=script&lang=js&"
export * from "./_DonationForm.vue?vue&type=script&lang=js&"
import style0 from "./_DonationForm.vue?vue&type=style&index=0&id=247dcbdd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247dcbdd",
  null
  
)

export default component.exports